// storage.js
export const CKey = 'C';
export const SKey = 's';

export function writeToStorage(key, value) {
    try {
        localStorage.setItem(key, value);
    } catch (e) {
        console.error('Error writing to ls', e);
    }
}

export function readFromStorage(key) {
    try {
        return localStorage.getItem(key);
    } catch (e) {
        console.error('Error reading from ls', e);
    }
}
